export { default as LocationInfoBanner } from './LocationInfoBanner';
